<template lang="html">
  <!-- Begin Mailchimp Signup Form -->
<div id="mc_embed_signup">
<form action="https://care.us20.list-manage.com/subscribe/post?u=5252c305584f88bce3a1b9685&amp;id=99450dc862" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
    <div id="mc_embed_signup_scroll">

	<input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address" required>
    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_5252c305584f88bce3a1b9685_99450dc862" tabindex="-1" value=""></div>
    <div class="clear"><input type="submit" value="I'm in" name="subscribe" id="mc-embedded-subscribe" class="button mc-button"></div>
    </div>
</form>
</div>

<!--End mc_embed_signup-->
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
#mc_embed_signup{background:#fff; clear:left; font-size:18px; width:100%;}
#mc_embed_signup form{text-align:left;}
#mc_embed_signup .button{
  background-color: rgba(227,100,174,1);
  border-color: rgba(227,100,174,1);
  border-width: 2px;
  border-radius: 20px;
  color: #f9eeea;
  font-size: 17px;
  text-transform: uppercase;
  height: 40px;
  line-height: 40px;
  padding: 0 40px;
  margin-left:40px;
}
#mc_embed_signup .button:hover{
  background-color: #3746aa;
  border-color: #3746aa;
  border-width: 2px;
  border-radius: 20px;
  color: #f9eeea;
  font-size: 17px;
  text-transform: uppercase;
  height: 40px;
  line-height: 40px;
  padding: 0 40px;
}

#mc_embed_signup input.email{
  background: transparent; border: 0; border-bottom: 2px solid #e364ae; border-radius: 0;
  width: 70%;
  }
#mc_embed_signup input.email:focus{outline:none;}
@media only screen and (max-width: 768px) {
    /* For mobile phones: */
    #mc_embed_signup input.email{
      width:100%;
      margin-bottom:24px;
    }
    #mc_embed_signup form{text-align:center;}
    #mc_embed_signup .button{
     margin-left:0;
    }
}
</style>
